import { TGetItemFn, TPageConfig, TSelectionPage } from '@/config/types'
import { PageName } from '@/enums/pageName'

export function getTitleFromPageConfig(
  getItem: TGetItemFn,
  currentPageName: PageName,
  pagesConfig: TPageConfig<TSelectionPage>
) {
  const optionIndex = Number(getItem(currentPageName))
  const options = pagesConfig[currentPageName]
  if (options && 'options' in options) {
    return options.options && options.options[optionIndex].title
  }
  return
}
